export const PIN = () => import('@/page/pintuan/pin.vue')
export const PIN_DETAIL = () => import('@/page/pintuan/detail.vue')
export const PIN_MY = () => import('@/page/pintuan/mypin.vue')
export const PIN_SUCCESS = () => import('@/page/pintuan/success.vue')
export const PIN_STATUS = () => import('@/page/pintuan/pinstatus.vue')
export const PIN_ORDER = () =>import('@/page/pintuan/confirmorder.vue')



// WEBPACK FOOTER //
// ./src/router/pintuan.js